/**
 * Global Notification System
 * Usage: window.showNotification(message, type, duration)
 * 
 * Example:
 * window.showNotification('Product added to cart!', 'success');
 * window.showNotification('Something went wrong', 'error', 5000);
 */

(function() {
  let notificationTimeout;
  
  window.showNotification = function(message, type = 'default', duration = 3000) {
    const notification = document.getElementById('global-notification');
    if (!notification) return;
    
    const messageEl = notification.querySelector('.global-notification__message');
    const closeBtn = notification.querySelector('.global-notification__close');
    
    // Clear any existing timeout
    if (notificationTimeout) {
      clearTimeout(notificationTimeout);
    }
    
    // Remove any existing type classes
    notification.classList.remove('success', 'error', 'warning', 'info', 'show');
    
    // Set message and type
    messageEl.textContent = message;
    if (type !== 'default') {
      notification.classList.add(type);
    }
    
    // Show notification
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    // Auto hide after duration
    notificationTimeout = setTimeout(() => {
      hideNotification();
    }, duration);
    
    // Close button handler
    closeBtn.onclick = function() {
      hideNotification();
    };
  };
  
  function hideNotification() {
    const notification = document.getElementById('global-notification');
    if (notification) {
      notification.classList.remove('show');
      if (notificationTimeout) {
        clearTimeout(notificationTimeout);
      }
    }
  }
  
  // Custom event listener for notifications
  window.addEventListener('show-notification', function(e) {
    const { message, type, duration } = e.detail;
    window.showNotification(message, type, duration);
  });
})();

